// // src/pages/Teams/TeamList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";

// export default function TeamList() {
//   const [teams, setTeams] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const loadTeams = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/teams");
//       setTeams(res.data.teams || []);
//     } catch (err) {
//       alert("Failed to load teams");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadTeams();
//   }, []);

//   return (
//     <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
//       <div className="max-w-5xl mx-auto">
//         <div className="flex justify-between items-center mb-10">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Teams</h1>
//           <button
//             onClick={loadTeams}
//             className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl shadow transition"
//           >
//             Refresh Teams
//           </button>
//         </div>

//         {loading ? (
//           <p className="text-center py-12 text-gray-500">Loading teams...</p>
//         ) : teams.length === 0 ? (
//           <p className="text-center py-12 text-gray-500">No teams created yet.</p>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {teams.map((team) => (
//               <div
//                 key={team.id}
//                 className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 hover:shadow-2xl transition"
//               >
//                 <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
//                   {team.name}
//                 </h3>

//                 {team.description && (
//                   <p className="text-gray-600 dark:text-gray-400 mb-6">
//                     {team.description}
//                   </p>
//                 )}

//                 <div className="space-y-4">
//                   <div>
//                     <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Team Leader</p>
//                     <p className="font-semibold text-lg">
//                       {team.leader?.name || "Not assigned"}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Members</p>
//                     <p className="text-3xl font-bold text-blue-600">
//                       {team.memberCount}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
//                   <p className="text-xs text-gray-500">
//                     Team ID: <span className="font-mono">{team.id}</span>
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


// // src/pages/Teams/TeamList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import {
//   UserGroupIcon,
//   PlusIcon,
//   PencilIcon,
//   UsersIcon,
//   XMarkIcon,
// } from "@heroicons/react/24/outline";

// export default function TeamList() {
//   const [teams, setTeams] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showMembersModal, setShowMembersModal] = useState(false);
//   const [selectedTeam, setSelectedTeam] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     description: "",
//     leader_id: "",
//   });

//   const loadData = async () => {
//     try {
//       setLoading(true);
//       const [teamsRes, usersRes] = await Promise.all([
//         api.get("/teams"),
//         api.get("/users"),
//       ]);
//       setTeams(teamsRes.data.teams || []);
//       setUsers(usersRes.data.users || []);
//     } catch (err) {
//       alert("Failed to load data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const handleCreate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.post("/teams", form);
//       setShowCreateModal(false);
//       setForm({ name: "", description: "", leader_id: "" });
//       loadData();
//       alert("Team created successfully!");
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to create team");
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.put(`/teams/${selectedTeam.id}`, form); // You'll need this endpoint later
//       setShowEditModal(false);
//       loadData();
//       alert("Team updated!");
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to update");
//     }
//   };

//   const openEdit = (team) => {
//     setSelectedTeam(team);
//     setForm({
//       name: team.name,
//       description: team.description || "",
//       leader_id: team.leader?.id || "",
//     });
//     setShowEditModal(true);
//   };

//   const openMembers = (team) => {
//     setSelectedTeam(team);
//     setShowMembersModal(true);
//   };

//   const teamMembers = selectedTeam
//     ? users.filter((u) => u.team_id === selectedTeam.id)
//     : [];

//   return (
//     <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-10">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
//             Teams Management
//           </h1>
//           <button
//             onClick={() => {
//               setForm({ name: "", description: "", leader_id: "" });
//               setShowCreateModal(true);
//             }}
//             className="px-6 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg flex items-center gap-3 transition"
//           >
//             <PlusIcon className="w-6 h-6" />
//             Create New Team
//           </button>
//         </div>

//         {/* Teams Grid */}
//         {loading ? (
//           <p className="text-center py-20 text-gray-500">Loading teams...</p>
//         ) : teams.length === 0 ? (
//           <div className="text-center py-20">
//             <UserGroupIcon className="w-20 h-20 text-gray-400 mx-auto mb-4" />
//             <p className="text-xl text-gray-500">No teams created yet</p>
//             <p className="text-gray-400 mt-2">Create your first team to organize users</p>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {teams.map((team) => (
//               <div
//                 key={team.id}
//                 className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 hover:shadow-2xl transition"
//               >
//                 <div className="flex justify-between items-start mb-6">
//                   <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
//                     {team.name}
//                   </h3>
//                   <button
//                     onClick={() => openEdit(team)}
//                     className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
//                   >
//                     <PencilIcon className="w-5 h-5 text-gray-500" />
//                   </button>
//                 </div>

//                 {team.description && (
//                   <p className="text-gray-600 dark:text-gray-400 mb-8">
//                     {team.description}
//                   </p>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
//                       Team Leader
//                     </p>
//                     <p className="text-lg font-semibold text-gray-900 dark:text-white">
//                       {team.leader?.name || "Not assigned"}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
//                       Total Members
//                     </p>
//                     <p className="text-4xl font-bold text-orange-600">
//                       {team.memberCount}
//                     </p>
//                   </div>
//                 </div>

//                 <button
//                   onClick={() => openMembers(team)}
//                   className="mt-8 w-full py-3 bg-orange-50 hover:bg-orange-100 dark:bg-orange-900/30 dark:hover:bg-orange-900/50 text-orange-700 dark:text-orange-400 font-medium rounded-xl flex items-center justify-center gap-2 transition"
//                 >
//                   <UsersIcon className="w-5 h-5" />
//                   View Members
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Create/Edit Modal */}
//       {(showCreateModal || showEditModal) && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8">
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold">
//                 {showCreateModal ? "Create New Team" : "Edit Team"}
//               </h2>
//               <button
//                 onClick={() => {
//                   setShowCreateModal(false);
//                   setShowEditModal(false);
//                 }}
//               >
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="space-y-6">
//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Name *</label>
//                 <input
//                   type="text"
//                   value={form.name}
//                   onChange={(e) => setForm({ ...form, name: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500"
//                   placeholder="e.g. Alpha Sales Team"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Description</label>
//                 <textarea
//                   rows={3}
//                   value={form.description}
//                   onChange={(e) => setForm({ ...form, description: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500"
//                   placeholder="Optional team purpose..."
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Leader</label>
//                 <select
//                   value={form.leader_id}
//                   onChange={(e) => setForm({ ...form, leader_id: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500"
//                 >
//                   <option value="">No leader</option>
//                   {users.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name} ({u.role})
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex justify-end gap-4 pt-4">
//                 <button
//                   onClick={() => {
//                     setShowCreateModal(false);
//                     setShowEditModal(false);
//                   }}
//                   className="px-6 py-3 border rounded-lg hover:bg-gray-100"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={showCreateModal ? handleCreate : handleUpdate}
//                   className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white rounded-lg font-bold"
//                 >
//                   {showCreateModal ? "Create Team" : "Update Team"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Members Modal */}
//       {showMembersModal && selectedTeam && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
//             <div className="p-6 border-b flex justify-between items-center">
//               <h2 className="text-2xl font-bold">
//                 {selectedTeam.name} — Members ({teamMembers.length})
//               </h2>
//               <button onClick={() => setShowMembersModal(false)}>
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="p-6 overflow-y-auto max-h-[60vh]">
//               {teamMembers.length === 0 ? (
//                 <p className="text-center text-gray-500 py-8">No members yet</p>
//               ) : (
//                 <div className="space-y-4">
//                   {teamMembers.map((member) => (
//                     <div
//                       key={member.id}
//                       className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
//                     >
//                       <div className="flex items-center gap-4">
//                         <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center font-bold text-orange-600 dark:text-orange-400">
//                           {member.name.charAt(0).toUpperCase()}
//                         </div>
//                         <div>
//                           <p className="font-semibold">{member.name}</p>
//                           <p className="text-sm text-gray-500">{member.role}</p>
//                         </div>
//                       </div>
//                       {selectedTeam.leader?.id === member.id && (
//                         <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">
//                           Leader
//                         </span>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // src/pages/Teams/TeamList.jsx — FULLY FIXED VERSION
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import {
//   UserGroupIcon,
//   PlusIcon,
//   PencilIcon,
//   UsersIcon,
//   XMarkIcon,
// } from "@heroicons/react/24/outline";

// export default function TeamList() {
//   const [teams, setTeams] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showMembersModal, setShowMembersModal] = useState(false);
//   const [selectedTeam, setSelectedTeam] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     description: "",
//     leader_id: "",
//   });

//   const loadData = async () => {
//     try {
//       setLoading(true);
//       const [teamsRes, usersRes] = await Promise.all([
//         api.get("/teams"),
//         api.get("/users"),
//       ]);
//       setTeams(teamsRes.data.teams || []);
//       setUsers(usersRes.data.users || []);
//     } catch (err) {
//       alert("Failed to load data");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const handleCreate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.post("/teams", form);
//       setShowCreateModal(false);
//       setForm({ name: "", description: "", leader_id: "" });
//       loadData();
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to create team");
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.put(`/teams/${selectedTeam.id}`, form);
//       setShowEditModal(false);
//       loadData();
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to update team");
//     }
//   };

//   const openEdit = (team) => {
//     setSelectedTeam(team);
//     setForm({
//       name: team.name,
//       description: team.description || "",
//       leader_id: team.leader?.id?.toString() || "",
//     });
//     setShowEditModal(true);
//   };

//   const openMembers = (team) => {
//     setSelectedTeam(team);
//     setShowMembersModal(true);
//   };

//   // Fixed: Get actual members using team_id
//   const teamMembers = selectedTeam
//     ? users.filter((u) => u.team_id === selectedTeam.id)
//     : [];

//   return (
//     <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
//       <div className="max-w-7xl mx-auto">
//         <div className="flex justify-between items-center mb-10">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
//             Teams Management
//           </h1>
//           <button
//             onClick={() => {
//               setForm({ name: "", description: "", leader_id: "" });
//               setShowCreateModal(true);
//             }}
//             className="px-6 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg flex items-center gap-3 transition"
//           >
//             <PlusIcon className="w-6 h-6" />
//             Create New Team
//           </button>
//         </div>

//         {loading ? (
//           <p className="text-center py-20 text-gray-500">Loading...</p>
//         ) : teams.length === 0 ? (
//           <div className="text-center py-20">
//             <UserGroupIcon className="w-32 h-32 text-gray-300 mx-auto mb-6" />
//             <p className="text-2xl text-gray-600">No teams yet</p>
//             <p className="text-gray-500 mt-2">Create your first team</p>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {teams.map((team) => (
//               <div
//                 key={team.id}
//                 className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 hover:shadow-2xl transition"
//               >
//                 <div className="flex justify-between items-start mb-6">
//                   <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
//                     {team.name}
//                   </h3>
//                   <button
//                     onClick={() => openEdit(team)}
//                     className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition"
//                   >
//                     <PencilIcon className="w-5 h-5 text-gray-500" />
//                   </button>
//                 </div>

//                 {team.description && (
//                   <p className="text-gray-600 dark:text-gray-400 mb-8">
//                     {team.description}
//                   </p>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">Team Leader</p>
//                     <p className="text-lg font-semibold">
//                       {team.leader?.name || "Not assigned"}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-sm font-medium text-gray-500">Members</p>
//                     <p className="text-4xl font-bold text-orange-600">
//                       {team.memberCount}
//                     </p>
//                   </div>
//                 </div>

//                 <button
//                   onClick={() => openMembers(team)}
//                   className="mt-8 w-full py-3 bg-orange-50 hover:bg-orange-100 dark:bg-orange-900/30 dark:hover:bg-orange-900/50 text-orange-700 dark:text-orange-400 font-medium rounded-xl flex items-center justify-center gap-2 transition"
//                 >
//                   <UsersIcon className="w-5 h-5" />
//                   View Members ({team.memberCount})
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Create/Edit Modal */}
//       {(showCreateModal || showEditModal) && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8">
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold">
//                 {showCreateModal ? "Create Team" : "Edit Team"}
//               </h2>
//               <button
//                 onClick={() => {
//                   setShowCreateModal(false);
//                   setShowEditModal(false);
//                 }}
//               >
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="space-y-6">
//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Name *</label>
//                 <input
//                   type="text"
//                   value={form.name}
//                   onChange={(e) => setForm({ ...form, name: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 dark:bg-gray-700"
//                   placeholder="Alpha Sales Team"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Description</label>
//                 <textarea
//                   rows={3}
//                   value={form.description}
//                   onChange={(e) => setForm({ ...form, description: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 dark:bg-gray-700"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Leader</label>
//                 <select
//                   value={form.leader_id}
//                   onChange={(e) => setForm({ ...form, leader_id: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 dark:bg-gray-700"
//                 >
//                   <option value="">No leader</option>
//                   {users.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name} ({u.role})
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex justify-end gap-4">
//                 <button
//                   onClick={() => {
//                     setShowCreateModal(false);
//                     setShowEditModal(false);
//                   }}
//                   className="px-6 py-3 border rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={showCreateModal ? handleCreate : handleUpdate}
//                   className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white rounded-lg font-bold"
//                 >
//                   {showCreateModal ? "Create" : "Update"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Members Modal - NOW SHOWS REAL MEMBERS */}
//       {showMembersModal && selectedTeam && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
//             <div className="p-6 border-b flex justify-between items-center">
//               <h2 className="text-2xl font-bold">
//                 {selectedTeam.name} — Members ({teamMembers.length})
//               </h2>
//               <button onClick={() => setShowMembersModal(false)}>
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="p-6 overflow-y-auto flex-1">
//               {teamMembers.length === 0 ? (
//                 <p className="text-center text-gray-500 py-12">No members assigned yet</p>
//               ) : (
//                 <div className="space-y-4">
//                   {teamMembers.map((member) => (
//                     <div
//                       key={member.id}
//                       className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
//                     >
//                       <div className="flex items-center gap-4">
//                         <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center font-bold text-orange-600">
//                           {member.name.charAt(0).toUpperCase()}
//                         </div>
//                         <div>
//                           <p className="font-semibold text-gray-900 dark:text-white">
//                             {member.name}
//                           </p>
//                           <p className="text-sm text-gray-500">{member.role || "Staff"}</p>
//                         </div>
//                       </div>
//                       {selectedTeam.leader?.id === member.id && (
//                         <span className="px-4 py-1.5 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
//                           Leader
//                         </span>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // src/pages/Teams/TeamList.jsx — 100% WORKING FINAL VERSION
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import {
//   UserGroupIcon,
//   PlusIcon,
//   PencilIcon,
//   UsersIcon,
//   XMarkIcon,
// } from "@heroicons/react/24/outline";

// export default function TeamList() {
//   const [teams, setTeams] = useState([]);
//   const [users, setUsers] = useState([]); // All users from /users
//   const [loading, setLoading] = useState(true);

//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showMembersModal, setShowMembersModal] = useState(false);
//   const [selectedTeam, setSelectedTeam] = useState(null);
  
//   const [form, setForm] = useState({
//     name: "",
//     description: "",
//     leader_id: "",
//   });

//   const loadData = async () => {
//     try {
//       setLoading(true);
//       const [teamsRes, usersRes] = await Promise.all([
//         api.get("/teams"),
//         api.get("/users"),
//       ]);

//       console.log("Teams loaded:", teamsRes.data.teams);
//       console.log("Users loaded:", usersRes.data.users);

//       setTeams(teamsRes.data.teams || []);
//       setUsers(usersRes.data.users || []);
//     } catch (err) {
//       console.error("Failed to load data:", err);
//       alert("Failed to load teams or users");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const handleCreate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.post("/teams", form);
//       setShowCreateModal(false);
//       setForm({ name: "", description: "", leader_id: "" });
//       await loadData(); // Refresh both teams and users
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to create team");
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.name.trim()) return alert("Team name is required");

//     try {
//       await api.put(`/teams/${selectedTeam.id}`, form);
//       setShowEditModal(false);
//       await loadData(); // Critical refresh
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to update team");
//     }
//   };

//   const openEdit = (team) => {
//     setSelectedTeam(team);
//     setForm({
//       name: team.name,
//       description: team.description || "",
//       leader_id: team.leader?.id ? String(team.leader.id) : "",
//     });
//     setShowEditModal(true);
//   };

//   const openMembers = (team) => {
//     setSelectedTeam(team);
//     setShowMembersModal(true);
//   };

//   // CRITICAL: Get members by team_id — convert both to number for safety
//   const teamMembers = selectedTeam
//     ? users.filter((user) => Number(user.team_id) === Number(selectedTeam.id))
//     : [];

//   return (
//     <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
//       <div className="max-w-7xl mx-auto">
//         <div className="flex justify-between items-center mb-10">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
//             Teams Management
//           </h1>
//           <div className="flex gap-4">
//             <button
//               onClick={loadData}
//               className="px-6 py-3 border rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition font-medium"
//             >
//               🔄 Refresh Data
//             </button>
//             <button
//               onClick={() => {
//                 setForm({ name: "", description: "", leader_id: "" });
//                 setShowCreateModal(true);
//               }}
//               className="px-6 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg flex items-center gap-3 transition"
//             >
//               <PlusIcon className="w-6 h-6" />
//               New Team
//             </button>
//           </div>
//         </div>

//         {loading ? (
//           <p className="text-center py-20 text-gray-500">Loading...</p>
//         ) : teams.length === 0 ? (
//           <div className="text-center py-20">
//             <UserGroupIcon className="w-32 h-32 text-gray-300 mx-auto mb-6" />
//             <p className="text-2xl text-gray-600">No teams yet</p>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {teams.map((team) => (
//               <div
//                 key={team.id}
//                 className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 hover:shadow-2xl transition"
//               >
//                 <div className="flex justify-between items-start mb-6">
//                   <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
//                     {team.name}
//                   </h3>
//                   <button onClick={() => openEdit(team)}>
//                     <PencilIcon className="w-5 h-5 text-gray-500 hover:text-gray-700" />
//                   </button>
//                 </div>

//                 {team.description && (
//                   <p className="text-gray-600 dark:text-gray-400 mb-8">
//                     {team.description}
//                   </p>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">Leader</p>
//                     <p className="text-lg font-semibold">
//                       {team.leader?.name || "None"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">Members</p>
//                     <p className="text-4xl font-bold text-orange-600">
//                       {team.memberCount}
//                     </p>
//                   </div>
//                 </div>

//                 <button
//                   onClick={() => openMembers(team)}
//                   className="mt-8 w-full py-3 bg-orange-50 hover:bg-orange-100 text-orange-700 font-medium rounded-xl flex items-center justify-center gap-2 transition"
//                 >
//                   <UsersIcon className="w-5 h-5" />
//                   View Members ({team.memberCount})
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Create/Edit Modal - unchanged except refresh on success */}
//       {(showCreateModal || showEditModal) && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8">
//             <div className="flex justify-between items-center mb-8">
//               <h2 className="text-2xl font-bold">
//                 {showCreateModal ? "Create Team" : "Edit Team"}
//               </h2>
//               <button
//                 onClick={() => {
//                   setShowCreateModal(false);
//                   setShowEditModal(false);
//                 }}
//               >
//                 <XMarkIcon className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="space-y-6">
//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Name *</label>
//                 <input
//                   type="text"
//                   value={form.name}
//                   onChange={(e) => setForm({ ...form, name: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-2">Description</label>
//                 <textarea
//                   rows={3}
//                   value={form.description}
//                   onChange={(e) => setForm({ ...form, description: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700 resize-none"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-2">Team Leader</label>
//                 <select
//                   value={form.leader_id}
//                   onChange={(e) => setForm({ ...form, leader_id: e.target.value })}
//                   className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700"
//                 >
//                   <option value="">No leader</option>
//                   {users.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name} ({u.role})
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex justify-end gap-4">
//                 <button
//                   onClick={() => {
//                     setShowCreateModal(false);
//                     setShowEditModal(false);
//                   }}
//                   className="px-6 py-3 border rounded-lg hover:bg-gray-100"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={showCreateModal ? handleCreate : handleUpdate}
//                   className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white rounded-lg font-bold"
//                 >
//                   {showCreateModal ? "Create" : "Update"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* View Members Modal — NOW 100% WORKING */}
//       {showMembersModal && selectedTeam && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col">
//             <div className="p-6 border-b flex justify-between items-center">
//               <h2 className="text-2xl font-bold">
//                 {selectedTeam.name} — Members ({teamMembers.length})
//               </h2>
//               <button onClick={() => setShowMembersModal(false)}>
//                 <XMarkIcon className="w-6 h-6 text-gray-500" />
//               </button>
//             </div>

//             <div className="p-6 overflow-y-auto">
//               {teamMembers.length === 0 ? (
//                 <p className="text-center text-gray-500 py-12">No members assigned yet</p>
//               ) : (
//                 <div className="space-y-4">
//                   {teamMembers.map((member) => (
//                     <div
//                       key={member.id}
//                       className="flex items-center justify-between p-5 bg-gray-50 dark:bg-gray-700 rounded-xl"
//                     >
//                       <div className="flex items-center gap-4">
//                         <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center text-xl font-bold text-orange-600">
//                           {member.name.charAt(0).toUpperCase()}
//                         </div>
//                         <div>
//                           <p className="font-semibold">{member.name}</p>
//                           <p className="text-sm text-gray-500">{member.role || "Staff"}</p>
//                         </div>
//                       </div>

//                       {/* Leader Badge */}
//                       {Number(selectedTeam.leader?.id) === Number(member.id) && (
//                         <span className="px-4 py-2 bg-orange-100 dark:bg-orange-900/50 text-orange-700 dark:text-orange-400 rounded-full text-sm font-bold">
//                           👑 Team Leader
//                         </span>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// src/pages/Teams/TeamList.jsx
import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import {
  UserGroupIcon,
  PlusIcon,
  PencilIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export default function TeamList() {
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]); // Keep for leader dropdown
  const [loading, setLoading] = useState(true);

  // New states for modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);         // ← Fresh members
  const [membersLoading, setMembersLoading] = useState(false); // ← Loading state

  const [form, setForm] = useState({
    name: "",
    description: "",
    leader_id: "",
  });

  const loadData = async () => {
    try {
      setLoading(true);
      const [teamsRes, usersRes] = await Promise.all([
        api.get("/teams"),
        api.get("/users"),
      ]);

      setTeams(teamsRes.data.teams || []);
      setUsers(usersRes.data.users || []);
    } catch (err) {
      console.error("Failed to load data:", err);
      alert("Failed to load teams or users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleCreate = async () => {
    if (!form.name.trim()) return alert("Team name is required");

    try {
      await api.post("/teams", form);
      setShowCreateModal(false);
      setForm({ name: "", description: "", leader_id: "" });
      await loadData();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to create team");
    }
  };

  const handleUpdate = async () => {
    if (!form.name.trim()) return alert("Team name is required");

    try {
      await api.put(`/teams/${selectedTeam.id}`, form);
      setShowEditModal(false);
      await loadData();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to update team");
    }
  };

  const openEdit = (team) => {
    setSelectedTeam(team);
    setForm({
      name: team.name,
      description: team.description || "",
      leader_id: team.leader?.id ? String(team.leader.id) : "",
    });
    setShowEditModal(true);
  };
const openMembers = async (team) => {
  setSelectedTeam(team);
  setMembersLoading(true);
  setTeamMembers([]);

  try {
    const usersRes = await api.get("/users");
    const freshUsers = usersRes.data.users || [];

    // FIND WHAT team_id VALUES ACTUALLY EXIST
    const teamIdValues = [...new Set(freshUsers.map(u => u.team_id).filter(Boolean))];
    console.log("Unique team_id values in users:", teamIdValues);

    // LOOSE COMPARISON + NULL CHECK
    const members = freshUsers.filter((user) => {
      return user.team_id != null && user.team_id == team.id;
    });

    console.log(`Found ${members.length} members for team ${team.id} (${team.name})`);
    members.forEach(m => console.log(`- ${m.name} (team_id: ${m.team_id}, type: ${typeof m.team_id})`));

    setTeamMembers(members);
  } catch (err) {
    console.error("Failed to load team members:", err);
    alert("Failed to load team members");
    setTeamMembers([]);
  } finally {
    setMembersLoading(false);
    setShowMembersModal(true);
  }
};
  
//   // ←←← THIS IS THE CRITICAL FIX ←←←
//   const openMembers = async (team) => {
//     setSelectedTeam(team);
//     setMembersLoading(true);
//     setTeamMembers([]);
//     setShowMembersModal(true);

//     try {
//       // Fetch fresh users every time modal opens
//       const usersRes = await api.get("/users");
//       const freshUsers = usersRes.data.users || [];

//       const members = freshUsers.filter(
//         (user) => Number(user.team_id) === Number(team.id)
//       );

//       setTeamMembers(members);
//     } catch (err) {
//       console.error("Failed to load team members:", err);
//       alert("Failed to load team members");
//       setTeamMembers([]);
//     } finally {
//       setMembersLoading(false);
//     }
//   };
  // ←←← END OF FIX ←←←

  return (
    <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Teams Management
          </h1>
          <div className="flex gap-4">
            <button
              onClick={loadData}
              className="px-6 py-3 border rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition font-medium"
            >
              Refresh Data
            </button>
            <button
              onClick={() => {
                setForm({ name: "", description: "", leader_id: "" });
                setShowCreateModal(true);
              }}
              className="px-6 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg flex items-center gap-3 transition"
            >
              <PlusIcon className="w-6 h-6" />
              New Team
            </button>
          </div>
        </div>

        {loading ? (
          <p className="text-center py-20 text-gray-500">Loading...</p>
        ) : teams.length === 0 ? (
          <div className="text-center py-20">
            <UserGroupIcon className="w-32 h-32 text-gray-300 mx-auto mb-6" />
            <p className="text-2xl text-gray-600">No teams yet</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teams.map((team) => (
              <div
                key={team.id}
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 hover:shadow-2xl transition"
              >
                <div className="flex justify-between items-start mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                    {team.name}
                  </h3>
                  <button onClick={() => openEdit(team)}>
                    <PencilIcon className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                  </button>
                </div>

                {team.description && (
                  <p className="text-gray-600 dark:text-gray-400 mb-8">
                    {team.description}
                  </p>
                )}

                <div className="space-y-6">
                  <div>
                    <p className="text-sm font-medium text-gray-500">Leader</p>
                    <p className="text-lg font-semibold">
                      {team.leader?.name || "None"}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Members</p>
                    <p className="text-4xl font-bold text-orange-600">
                      {team.memberCount}
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => openMembers(team)}
                  className="mt-8 w-full py-3 bg-orange-50 hover:bg-orange-100 text-orange-700 font-medium rounded-xl flex items-center justify-center gap-2 transition"
                >
                  <UsersIcon className="w-5 h-5" />
                  View Members ({team.memberCount})
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Create/Edit Modal */}
      {(showCreateModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold">
                {showCreateModal ? "Create Team" : "Edit Team"}
              </h2>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                }}
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">Team Name *</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Description</label>
                <textarea
                  rows={3}
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700 resize-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Team Leader</label>
                <select
                  value={form.leader_id}
                  onChange={(e) => setForm({ ...form, leader_id: e.target.value })}
                  className="w-full px-4 py-3 border rounded-lg dark:bg-gray-700"
                >
                  <option value="">No leader</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.role || "Staff"})
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() => {
                    setShowCreateModal(false);
                    setShowEditModal(false);
                  }}
                  className="px-6 py-3 border rounded-lg hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={showCreateModal ? handleCreate : handleUpdate}
                  className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white rounded-lg font-bold"
                >
                  {showCreateModal ? "Create" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Members Modal - NOW SHOWS CORRECT MEMBERS */}
      {showMembersModal && selectedTeam && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col">
            <div className="p-6 border-b flex justify-between items-center">
              <h2 className="text-2xl font-bold">
                {selectedTeam.name} — Members ({selectedTeam.memberCount})
              </h2>
              <button onClick={() => setShowMembersModal(false)}>
                <XMarkIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto">
              {membersLoading ? (
                <p className="text-center text-gray-500 py-12">Loading members...</p>
              ) : teamMembers.length === 0 ? (
                <p className="text-center text-gray-500 py-12">No members assigned yet</p>
              ) : (
                <div className="space-y-4">
                  {teamMembers.map((member) => (
                    <div
                      key={member.id}
                      className="flex items-center justify-between p-5 bg-gray-50 dark:bg-gray-700 rounded-xl"
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center text-xl font-bold text-orange-600">
                          {member.name.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <p className="font-semibold">{member.name}</p>
                          <p className="text-sm text-gray-500">
                            {member.role || "Staff"} • {member.email}
                          </p>
                        </div>
                      </div>

                      {Number(selectedTeam.leader?.id) === Number(member.id) && (
                        <span className="px-4 py-2 bg-orange-100 dark:bg-orange-900/50 text-orange-700 dark:text-orange-400 rounded-full text-sm font-bold">
                          Team Leader
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}